module.exports = __webpack_public_path__ + "static/media/bottom-left.bab681b4.svg";